<script>
import Swal from "sweetalert2";
import Choices from "choices.js";
import { productListMethods, productListComputed, layoutMethods, exportMethods,erpFixMessages, erpUserRolesMethods } from "@/state/helpers";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Multiselect from "vue-multiselect";
import { getModuleAccess } from '@/router/helper.js'
import { XlsxRead, XlsxJson, XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx/dist/vue-xlsx.es";


/**
 * Product listing component
 */
export default {
  page: {
    title: "Product Suggestion",
  },
  components: {
    flatPickr,
    Multiselect,
    XlsxRead,
    XlsxJson,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload
  },
  data() {
    return {
      createModal: false,
      editModal: false,
      title: "Product Suggestion",
      folder: "product-images",
      is_searching: false,
      pagination: {
        rows: 10,
        page: 1,
        keyword: '',
        field: null,
        brand: '',
        group: '',
        dateRange: '',
        sort: 'id',
        orderDesc: true
      },
      lookupParams: {
        keyword: '',
        field: null,
        brand: '',
        group: '',
        dateRange: ''
      },
      productTemplateItem: {
        productName: '',
        categoryIds: [],
        groupId: null,
        brandId: null,
        srp: 0,
        cost: 0,
        uom: {
          unit: '',
          name: '',
          method: ''
        },
        productCode: ''
      },
      searchOptions: [
        { text: 'Search All', value: null },
        { text: 'Product Name', value: 'name' },
        { text: 'Product Code', value: 'code' },
        { text: 'Brand Name', value: 'brand' },
        { text: 'Category Name', value: 'group' }
      ],
      pageOptions: [10, 20, 30, 40, 50, 60, 60, 70, 80, 90, 100],
      fieldsProductListing: [
        {
          key: "action",
          sortable: false,
        },

        {
          key: "productName",
          sortable: true,
        },

        {
          key: "productCode",
          sortable: true,
        },

        {
          key: "brandName",
          sortable: true,
        },

        {
          key: "groupName",
          label: "Product Category",
          sortable: true,
        },

        {
          key: "srp",
          sortable: true,
          // tdClass: "text-end",
          // thClass: "text-end",
        },

        {
          key: "cost",
          sortable: true,
          // tdClass: "text-end",
          // thClass: "text-end",
        },
      ],
      productImage: {
        filename: null,
        type: null,
        base64: null
      },
      rangeOptions: {
        mode: "range",
      },
      productSuggestionModule: {
        access: {
          create: true,
          delete: true
        }
      },
      file: null,
      sheets: [
        { 
          name: "Sheet1", 
          data: [
            {
              // img: "Filename ex. product_photo.png",
              name: "Product Name ex. Nescafe Creamy White",
              brand_id: "Refer to Brands sheet. Should be 1 brand id only.",
              brand: "Product Brand name. Refer to Brands sheet. Should be 1 brand only.",
              business_category_id: 'Refer to Business Categories sheet. Could be multiple and comma-separated',
              business_category: "Refer to Business Categories sheet. Could be multiple and comma-separated",
              product_category_id: "Refer to Product Categories sheet. Should be 1 product category id only.",
              product_category: "Refer to Product Categories sheet. Should be 1 product category only.",
              uom_id: "Refer to Unit of Measurements sheet. Should be 1 uom id only.",
              uom: "Piece, Kilogram, etc. Refer to Unit of Measurements sheet. Should be 1 uom only.",
              srp: "Product SRP",
              cost: "Product Cost",
              sku: "Product Unique Code",
            }
          ] 
        },
        {
          name: "Product Categories",
          data: [ { name: "Product Categories", } ]
        },
        {
          name: "Business Categories",
          data: [ { name: "Business Categories", } ]
        },
        {
          name: "Brands",
          data: [ { name: 'Brand Name', } ]
        },
        {
          name: "Unit of Measurements",
          data: [ { name: 'Unit of Measurements', } ]
        }
      ],
    };
  },
  computed: {
    ...productListComputed,
    ...erpFixMessages,
    productBrand: {
      get() {
        var productBrand = null;
        this.productBrandOptions.forEach((b) => {
          if (b.value == this.lookupParams.brand) {
            productBrand = b;
          }
        });
        return productBrand;
      },
      set(productBrand) {
        if (productBrand) {
          this.lookupParams.brand = productBrand.value;
        } else {
          this.lookupParams = null;
        }
      },
    },
    productGroup: {
      get() {
        var productGroup = null;
        this.productGroupOptions.forEach((g) => {
          if (g.value == this.lookupParams.group) {
            productGroup = g;
          }
        });
        return productGroup;
      },
      set(productGroup) {
        if (productGroup) {
          this.lookupParams.group = productGroup.value;
        } else {
          this.lookupParams.group = null;
        }
      },
    },
    productGroupOptions: {
      get() {
        var groups = [{ text: 'All', value: '' }];
        this.productGroups.forEach(group => {
          groups.push({ 'text': group.groupName, 'value': group.groupId })
        });
        return groups;
      }
    },
    productCategoryOptions: {
      get() {
        return this.businessCategories.map(category => {
          return { 'text': category.productName, 'value': category.productId }
        });
      }
    },
    productBrandOptions: {
      get() {
        var brands = [{ text: 'All', value: '' }];
        this.productBrands.map(brand => {
          brands.push({ 'text': brand.productBrandName, 'value': brand.productId })
        });
        return brands;
      }
    }
  },
  methods: {
    ...layoutMethods,
    ...productListMethods,
    ...exportMethods,
    ...erpUserRolesMethods,
    async onRefresh() {
      if (this.is_searching) await this.searchProd()
      else await this.getProdList()
    },
    async search() {
      this.pagination.page = 1;
      this.pagination = Object.assign(this.pagination, this.lookupParams);
      await this.listProdTemplates();
    },
    async listProdTemplates() {
      await this.listProductTemplates(this.pagination);
    },
    deleteProdTemplate(productTemplate) {
      if (!this.productSuggestionModule.access.delete) {
        Swal.fire(
          "Access Restricted",
          "You are not allowed to delete a Product Suggestion.",
          "warning"
        );
      } else {
        Swal.fire({
          title: "Are you sure?",
          text: `Do you really want to delete ${productTemplate.productName}? This process cannot be undone.`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Yes",
          cancelButtonText: 'No'
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteProductTemplate(productTemplate.productId)
              .then(() => {
                Swal.fire("Delete Successful!", `${productTemplate.productName} has been deleted.`, "success");
                this.listProdTemplates();
              })
              .catch((err) => {
                console.log(err);
                Swal.fire("Delete Failed!", `An Error Occured: ${err}`, "danger");
              });
          } else {
            return;
          }
        });
      }
    },
    openCreateModal() {
      this.clearProductTemplate();
      this.clearLogo();
      this.createModal = true;
      this.initializeChoices();
    },
    openEditModal() {
      this.isEditModalOpen = true;
      this.initializeChoices();
    },
    handleSort(ctx) {
      console.log(ctx);
      this.pagination.sort = ctx.sortBy;
      this.pagination.orderDesc = ctx.sortDesc;
      this.listProdTemplates();
    },
    clearProductTemplate() {
      this.productTemplateItem = {
        productName: '',
        categoryIds: [],
        groupId: null,
        brandId: null,
        srp: 0,
        cost: 0,
        uom: {
          unit: '',
          name: '',
          method: ''
        },
        productCode: ''
      };
    },
    initializeChoices() {
      setTimeout(function () {
        new Choices("#business-category-selection", {
          removeItemButton: true,
        });
      }, 100);
    },
    clearLogo() {
      this.productImage = {
        filename: null,
        type: null,
        base64: null
      }
    },
    async onExport(){
      var self = this;
      await this.onSearch().then(function(){
        console.log("check this:",self.templateTotalRows);
        if(self.templateTotalRows ==0 ){
          Swal.fire("Failed!", self.exportNullPrompt, "warning");
        }else{
          let params = Object.assign(
            self.pagination, 
            self.lookupParams, 
            {
              module: 'product_suggestions',
              email: JSON.parse(localStorage.getItem('userData')).email
            });

          delete params.page;
          delete params.rows;
          
          self.exportReport(params)
            .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
            .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
        }
      });
    },
    async onSearch() {
      this.pagination = {
        rows: 10,
        page: 1,
        keyword: '',
        field: 'name',
        brand: '',
        group: '',
        dateRange: '',
        sort: 'id',
        orderDesc: true
      }
      if (this.lookupParams.keyword != '' || this.lookupParams.group != '' || this.lookupParams.brand != '' || this.lookupParams.dateRange != '') {
        this.is_searching = true
        this.pagination.page = 1
        await this.searchProd()
      } else {
        this.is_searching = false
        await this.getProdList()
      }
    },
    async getProdList() {
      await this.listProductTemplates(this.pagination)
    },
    async searchProd() {
      let params = Object.assign(this.pagination, this.lookupParams);
      await this.listProductTemplates(params)
    },
    onChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
    },
    output(event) {
      this.setProductSuggestionList(event)
        .then(() => {
          console.log('productSuggestionsCount: ', this.productSuggestionList, this.productSuggestionList.length)
          this.$router.push({ path: 'template/import'})
        });
    },
    populateBrands() {
        let index = this.sheets.findIndex(( item ) => item.name == 'Brands');
        this.sheets[index].data = [];
        this.productBrands.map(brand => {
          this.sheets[index].data.push({ 
            id: brand.productId, 
            name: brand.productBrandName 
          });
        })
    },
    populateBusinessCategories() {
        let index = this.sheets.findIndex(( item ) => item.name == 'Business Categories');
        this.sheets[index].data = [];
        this.businessCategories.map(category => {
          this.sheets[index].data.push({ 
            id: category.productId, 
            name: category.productName 
          });
        });
    },
    populateProductCategories() {
        let index = this.sheets.findIndex(( item ) => item.name == 'Product Categories');
        this.sheets[index].data = [];
        this.productGroups.map(group => {
          this.sheets[index].data.push({ 
            id: group.groupId, 
            name: group.groupName 
          });
        });
    },
    populateUOM() {
        let index = this.sheets.findIndex(( item ) => item.name == 'Unit of Measurements');
        this.sheets[index].data = [];
        this.unitOfMeasurementList.map(uom => {
          this.sheets[index].data.push({ 
            id: uom.id, 
            name: uom.name,
            unit: uom.unit
          });
        });
    },
  },
  async mounted() {
    // Dropdown values
    this.listProductBrands({ rows: 99999, sort: 'name', orderDesc: false }).then(() => {
      this.populateBrands();
    });
    this.listProductGroups({ rows: 99999, sort: 'name', orderDesc: false }).then(() => {
      this.populateProductCategories();
    });
    this.listBusinessCategories({ rows: 99999 }).then(() => {
      this.populateBusinessCategories();
    });
    this.getUnitOfMeasureList().then(() => {
      this.populateUOM();
    })

    // Product list
    this.listProdTemplates();
    this.changeTitle({ title: 'Product Suggestion' });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home' } },
        { text: 'Product Template', to: { name: 'Product' } },
        { text: 'Product Suggestion', to: { name: 'Product Template' } }
      ]
    });

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Utilities', 'Product Template', 'Product Suggestion')
        .then((access) => this.productSuggestionModule.access = access);

  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4">
                <div class="my-2">
                  <h5 class="card-title">
                    <span class="fw-normal ms-lg-2">{{ templateTotalRows }}</span> Record(s)
                  </h5>
                </div>
              </div>
              <!-- end col -->

              <div class="col-md-8 col-sm-8">
                <div class="d-flex justify-content-lg-end mb-lg-3">
                  <template>
                    <div class="me-2">
                      <router-link v-if="productSuggestionModule.access.create" :to="{ name: 'Product Template Form' }" class="btn btn-primary"><i
                          class="uil uil-plus me-1"></i> Add Product</router-link>
                    </div>
                  </template>

                  <a class="btn btn-secondary" @click="onRefresh">
                    <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; Refresh
                  </a>
                </div>
              </div>
              <!-- end col -->

              <div class="d-flex mt-3 mb-3 d-flex flex-wrap">
                <div class="me-3 ta-right">
                  <b-form-group description="Search keyword">
                    <div class="d-flex">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                        v-model="lookupParams.field" :options="searchOptions"></b-form-select>
                      <b-form-input v-on:keyup.enter="onSearch" v-model="lookupParams.keyword" class="rounded-0">
                      </b-form-input>
                    </div>
                  </b-form-group>
                </div>
                <div class="me-2 ta-right w-200px">
                  <b-form-group description="Filter by brand">
                    <multiselect v-model="productBrand" :options="productBrandOptions" track-by="value" label="text"
                      select-label="Click to select" deselect-label="Click to remove" placeholder="Select Brand"
                      :allow-empty="false" :preselect-first="true"></multiselect>
                  </b-form-group>
                </div>
                <div class="me-2 ta-right w-200px">
                  <b-form-group description="Filter by category">
                    <multiselect v-model="productGroup" :options="productGroupOptions" track-by="value" label="text"
                      select-label="Click to select" deselect-label="Click to remove" placeholder="Select Category"
                      :allow-empty="false" :preselect-first="true"></multiselect>
                  </b-form-group>
                </div>
                <div class="me-3 ta-right">
                  <b-form-group description="Filter by date">
                    <flat-pickr v-model="lookupParams.dateRange" :config="rangeOptions"
                      placeholder="Select a date range" class="form-control"></flat-pickr>
                  </b-form-group>
                </div>
                <div class="">
                  <b-form-group label="">
                    <b-button variant="primary" type="button" @click="onSearch" class="px-2 btn btn-primary h-fit me-2">
                      <i class='bx bx-search bx-fw'></i> Search
                    </b-button>
                  </b-form-group>
                </div>
                <div class="">
                  <b-form-group label="">
                    <b-button variant="primary" type="button" @click="onExport" class="px-2 btn btn-primary h-fit me-2">
                      <i class='uil uil-export me-1'></i> Export
                    </b-button>
                  </b-form-group>
                </div>
                <div class="">
                  <b-form-group label="">
                    <b-button variant="primary" type="button" @click="$refs.exportExcelBtn.click()" class="px-2 btn btn-primary h-fit me-2">
                      <i class='uil uil-download-alt me-1'></i> Download Template
                    </b-button>
                  </b-form-group>
                </div>
                <div class="" v-if="productSuggestionModule.access.create">
                  <b-form-group label="">
                    <b-button variant="primary" type="button" @click="$refs.importExcelBtn.click()" class="px-2 btn btn-primary h-fit">
                      <i class='uil uil-import me-1'></i> Import
                    </b-button>
                  </b-form-group>
                </div>
              </div>
            </div>
            <!-- end row -->

            <!-- table -->
            <template>
              <div class="table-responsive">
                <div class="table align-middle table-nowrap">
                  <b-table :items="productTemplates" :fields="fieldsProductListing"
                    :no-local-sorting="true" @sort-changed="handleSort">
                    <template #cell(action)="row">
                      <div class="d-flex">
                        <button class="btn btn-sm btn-danger" @click="deleteProdTemplate(row.item)">
                          <i class="bx bx-trash bx-xs bx-fw"></i>
                        </button>
                      </div>
                    </template>

                    <template #cell(productName)="row">
                      <router-link class="text-primary font-size-14 fw-bold"
                        :to="{ name: 'Product Template Form', params: { productId: row.item.productId } }">
                        {{ row.item.productName }}
                      </router-link>
                    </template>

                    <template #cell(srp)="row">
                      ₱{{ row.item.srp.toFixed(2) }}
                    </template>

                    <template #cell(cost)="row">
                      ₱ {{ row.item.cost.toFixed(2) }}
                    </template>
                  </b-table>
                </div>
              </div>
            </template>
            <div class="row g-0 text-center" v-if="templateTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0 text-center text-sm-start" v-if="templateTotalRows != 0 && templateTotalRows > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit" id="display-record"
                            v-model="pagination.rows" :options="pageOptions" @change="onRefresh"></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      ">
                      <!-- pagination -->
                      <b-pagination class="pagination-rounded" v-model="pagination.page" @input="onRefresh"
                        :total-rows="templateTotalRows" :per-page="pagination.rows"></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->

        <template>
          <div class="no-height">
            <input type="file" @change="onChange" ref="importExcelBtn"/>
            <xlsx-read :file="file">
              <xlsx-json @parsed="output">
                <template #default="{collection}">
                  <div>
                    {{ collection }}
                  </div>
                </template> 
              </xlsx-json>
            </xlsx-read>
          </div>
        </template>

        <template>
          <section class="no-height">
            <xlsx-workbook>
              <xlsx-sheet
                :collection="sheet.data"
                v-for="sheet in sheets"
                :key="sheet.name"
                :sheet-name="sheet.name"
              />
              <xlsx-download filename="Product-Suggestion-Template.xlsx">
                <button ref="exportExcelBtn">Download</button>
              </xlsx-download>
            </xlsx-workbook>
          </section>
        </template>
      </div>
      <!-- end col -->
    </div>
  </div>
</template>

<style>
.m-150px {
  min-width: 150px;
}

.w-300px {
  width: 300px;
}

.w-200px {
  width: 200px;
}


.multiselect.invalid .multiselect__tags {
  border-color: #f34e4e;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.invalid~.invalid-feedback {
  display: block;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background: #f8f9fa;
  color: #495057;
}

.multiselect__tag {
  background-color: #e73092 !important;
  border-color: #e73092 !important;
  margin-bottom: 0 !important;
  font-weight: 400 !important;
}

.multiselect__tag-icon:after {
  color: #fff !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background-color: #e73092 !important;
}

.w-100px {
  width: 100px;
}

.no-height {
  height: 0;
  display: none;
}
</style>